module.exports = __webpack_public_path__ + "img/29_69.a1915b84.png";